import styled from "@emotion/styled";

import BlueBalloon from "./blue-balloon.svg";
import OrangeBalloon from "./orange-balloon.svg";

export const StyledBlueBalloon = styled(BlueBalloon)``;

export const StyledOrangeBalloon = styled(OrangeBalloon)``;

export const Container = styled.div`
  ${StyledOrangeBalloon} {
    position: relative;
    inset-block-start: 66px;
  }

  ${StyledBlueBalloon} {
    position: relative;
    inset-inline-end: -64px;
  }
`;
